import { createFileRoute, Link } from '@tanstack/react-router';
import { CircleArrowLeft, Copy } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '~shared/shadcn/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Input } from '~shared/shadcn/ui/input';

const bugReportForm = 'https://help.enrollio.ai/';
const featureForm = 'https://roadmap.enrollio.ai/';

export const Route = createFileRoute('/_auth/_layout/bugs-feature')({
  component: RouteComponent,
});

function RouteComponent() {
  const copyToClipboard = async (type: 'bug' | 'feature') => {
    const link = type === 'bug' ? bugReportForm : featureForm;
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link copied!', {
        description: 'The form link has been copied to your clipboard.',
      });
    } catch (err) {
      console.error('🚀 ~ copyToClipboard ~ err:', err);
      toast.error('Failed to copy', {
        description: 'Please try copying the link manually.',
      });
    }
  };
  return (
    <div className='flex flex-col gap-8'>
      <Link to='/dashboard' className='flex items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back to Dashboard</span>
      </Link>
      <Card className='mx-auto max-w-2xl bg-primary/30'>
        <CardHeader>
          <CardTitle className='text-2xl md:text-2xl'>Report a Bug</CardTitle>
          <CardDescription className='text-base md:text-lg'>
            Found an issue? Let us know so we can fix it.
          </CardDescription>
        </CardHeader>
        <CardContent className='w-[500px] space-y-6'>
          <div className='space-y-2'>
            {/* <p className='text-sm text-muted-foreground'>
              Parents and students can use this link to register for classes,
              pay tuition, and communicate with staff.
            </p> */}
            <div className='flex space-x-2'>
              <Input
                readOnly
                value={bugReportForm}
                className='font-mono text-sm ring-1 ring-ring'
              />
              <Button
                variant='secondary'
                size='icon'
                onClick={() => copyToClipboard('bug')}
                aria-label='Copy registration link'
              >
                <Copy className='size-4' />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className='mx-auto max-w-2xl'>
        <CardHeader>
          <CardTitle className='text-2xl md:text-2xl'>
            Suggest a Feature
          </CardTitle>
          <CardDescription className='text-base md:text-lg'>
            Share your ideas to help us improve.
          </CardDescription>
        </CardHeader>
        <CardContent className='w-[500px] space-y-6'>
          <div className='space-y-2'>
            {/* <p className='text-sm text-muted-foreground'>
              Parents and students can use this link to register for classes,
              pay tuition, and communicate with staff.
            </p> */}
            <div className='flex space-x-2'>
              <Input
                readOnly
                value={featureForm}
                className='font-mono text-sm'
              />
              <Button
                variant='secondary'
                size='icon'
                onClick={() => copyToClipboard('feature')}
                aria-label='Copy registration link'
              >
                <Copy className='size-4' />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
